import { Model, View } from "@lernetz/ts-lib";

export class SvelteView extends View<Model> {
  root: any;
  instance: any;

  constructor(root: any) {
    super({ template: "" });

    this.root = root;
  }

  init() {
    this.data = new Model(this.data);

    let context = new Map();
    context.set("ts-lib-context", this.template.context);

    this.instance = new this.root({
      target: this.node,
      props: this.data,
      context,
    });

    this.data.propertyChange.subscribe((e) => {
      let d = {};
      d[e.name] = this.data[e.name];
      this.instance.$$set(d);
    });
  }
}
